import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import qs from 'qs';
import PageComponent from '../../components/PageComponent';
import AppLayout from '../../layouts/AppLayout';
import RenderQueuePane from '../StorageManager/components/fs-actions/RenderQueuePane';

class RenderQueue extends PageComponent {
  componentDidMount() {
    localStorage.setItem('last_view', 'render_queue');
  }

  handleNavigateToAction = (actionID) => {
    const { history } = this.props;
    // Navigate to storage manager with the action ID
    history.push(`/storage?action_id=${actionID}`);
  };

  render() {
    const { location } = this.props;
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    const queueID = params.queueID ? parseInt(params.queueID, 10) : null;
    const jobID = params.jobID ? parseInt(params.jobID, 10) : null;

    return (
      <AppLayout
        title="Render Queue"
        className="render-queue-page"
      >
        <RenderQueueContainer>
          <RenderQueuePane
            initialQueueID={queueID}
            initialJobID={jobID}
            onNavigateToAction={this.handleNavigateToAction}
          />
        </RenderQueueContainer>
      </AppLayout>
    );
  }
}

const RenderQueueContainer = styled.div`
  padding: 15px;
  height: calc(100vh - 50px); /* Adjust for header height */
  overflow: hidden;
`;

function mapStateToProps(state, ownProps) {
  const { user } = state;
  return {
    user,
    location: ownProps.location
  };
}

export default connect(mapStateToProps)(withRouter(RenderQueue));

